import styled from 'styled-components'
import {PageLayout} from '@layouts/page-layout/PageLayout.tsx'

export const StyledPageLayoutConversationHystory = styled(PageLayout)`
    gap: 0;
`
